module.exports = __webpack_public_path__ + "img/1596185008.4ab57339.jpg";